import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class UserFeedbackService {
    constructor(
        private apiHttp: ApiHttp) {
    }

    public getUserFeedbacks(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserFeedback/GetUserFeedbacks', data, messageService);
    }

    public getUserFeedbackDetail(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUserFeedback/GetUserFeedbackDetail', data, messageService);
    }

    public closeFeedback(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUserFeedback/CloseFeedback', data, messageService);
    }
}
